/**
 * The ASSIST icon set (in @assist/core, shared with the OpenMRS module), drawn for Preact.
 */
import { ICONS } from '@assist/core';

export { HUE, ICONS, packIcon } from '@assist/core';

export function Icon({ k, size = 22 }: { k: string; size?: number }) {
  return (
    <svg
      class="uic"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: constant icon markup from this file
      dangerouslySetInnerHTML={{ __html: ICONS[k] ?? ICONS.more ?? '' }}
    />
  );
}

/** The ASSIST mark: a pulse line on gold. */
export function Mark({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M2 12h4l2 6 4-12 2 8 2-2h6" />
    </svg>
  );
}
